import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const IfCondition = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                flex: 1,
                overflowY: 'auto',
                padding: '24px',
            }}
        >
            <Typography variant="body1" style={{ width: isMediumScreen ? '100%' : '40%' }}>
                <strong>If Condition</strong>
                <br /><br />
                <p>
                    In this example, we demonstrate how to use an <strong>If Condition</strong> node after a <strong>For Loop </strong> 
                    to control flow execution based on a specific condition. The condition checks whether the current loop 
                    index is equal to <code>2</code>. If the condition evaluates to true, the <strong>Posts API</strong> is executed.
                </p>
            </Typography>

            <img
                src="/flows/IfCondition/IfConditionBoard.png"
                alt="Flow showing If Condition after For Loop"
                style={{
                    width: isMediumScreen ? '100%' : '80%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography variant="body1" style={{ width: isMediumScreen ? '100%' : '40%' }}>
                <strong>Setting the Loop Index in Flowstore</strong>
                <br /><br />
                <p>
                    After selecting the <strong>For Loop</strong> node, open the <em>flow variables</em> panel and set the index value 
                    to a flow variable (e.g., <code>index</code>). This variable will be used in the <strong>If Condition </strong> 
                    to check whether <code>index === 2</code>.
                </p>
            </Typography>

            <img
                src="/flows/IfCondition/IfConditionForLoopIndexset.png"
                alt="Setting index value in For Loop node"
                style={{
                    width: isMediumScreen ? '100%' : '80%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography variant="body1" style={{ width: isMediumScreen ? '100%' : '40%' }}>
                <strong>Flow Execution</strong>
                <br /><br />
                <p>
                    As shown below, during runtime, the <strong>Posts API</strong> is triggered only when the loop index is 
                    <code>2</code>. This highlights how conditional logic can be applied to control which parts of a flow are executed.
                </p>
            </Typography>

            <img
                src="/flows/IfCondition/IfCondtionBoardRun.png"
                alt="Flow execution showing Posts API run only when index is 2"
                style={{
                    width: isMediumScreen ? '100%' : '80%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />
        </Box>
    );
};

export default IfCondition;
